if (!customElements.get('bundle-add')) {
  customElements.define(
    'bundle-add',
    class BundleAdd extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button.bundle-card__cta');
        this.label = this.querySelector('.bundle-card__cta-label');
        this.spinner = this.querySelector('.bundle-card__cta-spinner');
        this.errorEl = this.querySelector('.bundle-card__error');
        // Only the cart-drawer can sensibly render a multi-item bundle add inline.
        // cart-notification is designed for single-product adds and breaks here,
        // so on those themes we redirect to /cart after the add (matches the
        // "review and remove items" UX requirement).
        this.cartDrawer = document.querySelector('cart-drawer');

        if (this.button) {
          this.button.addEventListener('click', this.onClick.bind(this));
        }
      }

      get variantIds() {
        return (this.dataset.variantIds || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        const ids = this.variantIds;
        if (!ids.length) return;

        this.clearError();
        this.setLoading(true);

        // Only request section rendering when we have a cart-drawer to repaint.
        const sections = this.cartDrawer
          ? this.cartDrawer.getSectionsToRender().map((section) => section.id)
          : [];

        const body = {
          items: ids.map((id) => ({ id: Number(id), quantity: 1 })),
          sections: sections.join(','),
          sections_url: window.location.pathname,
        };

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(body);

        if (this.cartDrawer && typeof this.cartDrawer.setActiveElement === 'function') {
          this.cartDrawer.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) =>
            response
              .json()
              .then((data) => ({ ok: response.ok, status: response.status, data }))
          )
          .then(({ ok, data }) => {
            if (!ok) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'bundle-add',
                bundleHandle: this.dataset.bundleHandle,
                errors: data.errors || data.description,
                message: data.message,
              });
              this.showError(
                data.description ||
                  data.message ||
                  (window.bundleStrings && window.bundleStrings.error) ||
                  'Could not add bundle to cart.'
              );
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundle-add',
              bundleHandle: this.dataset.bundleHandle,
              cartData: data,
            });

            if (this.cartDrawer) {
              this.cartDrawer.renderContents(data);
              if (this.cartDrawer.classList.contains('is-empty')) {
                this.cartDrawer.classList.remove('is-empty');
              }
            } else {
              // No cart-drawer on this theme — go to /cart so the customer
              // can review the added items and remove any they don't want.
              window.location.href =
                (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch((err) => {
            console.error('bundle-add error', err);
            this.showError(
              (window.bundleStrings && window.bundleStrings.error) ||
                'Network error. Please try again.'
            );
          })
          .finally(() => {
            this.setLoading(false);
          });
      }

      setLoading(on) {
        if (!this.button) return;
        this.button.classList.toggle('loading', on);
        this.button.setAttribute('aria-disabled', on ? 'true' : 'false');
        if (this.spinner) this.spinner.classList.toggle('hidden', !on);
        if (this.label) this.label.classList.toggle('hidden', on);
      }

      showError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg;
        this.errorEl.classList.remove('hidden');
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.add('hidden');
      }
    }
  );
}
